/**
 * Demo results for one subject (the CEO) across their competency domains.
 * Values are indexed by domain order; the page joins them to the framework.
 */
export const SCORING_SUBJECT_ID = 'p2'
export const SCORING_ROLE_ID = 'ceo'
export const SCORING_CYCLE = '2026 Executive Effectiveness Review'

export type DomainScore = {
  self: number
  board: number
  peers: number
  directs: number
  characteristic: number
  behaviour: number
}

export const DOMAIN_SCORES: DomainScore[] = [
  { self: 4.7, board: 4.4, peers: 4.2, directs: 4.1, characteristic: 4.4, behaviour: 4.1 },
  { self: 4.5, board: 3.4, peers: 3.2, directs: 3.0, characteristic: 3.6, behaviour: 3.0 },
  { self: 4.0, board: 4.6, peers: 4.5, directs: 4.4, characteristic: 4.4, behaviour: 4.6 },
  { self: 4.1, board: 3.9, peers: 3.8, directs: 3.7, characteristic: 4.0, behaviour: 3.6 },
  { self: 4.3, board: 3.8, peers: 3.5, directs: 3.3, characteristic: 3.8, behaviour: 3.4 },
  { self: 3.6, board: 4.0, peers: 3.9, directs: 4.1, characteristic: 3.9, behaviour: 4.0 },
  { self: 4.2, board: 4.3, peers: 4.0, directs: 3.9, characteristic: 4.2, behaviour: 4.0 },
  { self: 4.4, board: 4.1, peers: 4.2, directs: 4.0, characteristic: 4.3, behaviour: 4.0 },
  { self: 3.9, board: 3.7, peers: 3.6, directs: 3.8, characteristic: 3.8, behaviour: 3.6 },
  { self: 4.6, board: 4.2, peers: 3.9, directs: 3.6, characteristic: 4.1, behaviour: 3.7 },
  { self: 4.0, board: 4.4, peers: 4.3, directs: 4.2, characteristic: 4.3, behaviour: 4.3 },
  { self: 4.2, board: 3.9, peers: 4.0, directs: 4.1, characteristic: 4.1, behaviour: 3.9 },
  { self: 4.1, board: 4.0, peers: 3.9, directs: 3.8, characteristic: 4.0, behaviour: 3.8 },
]
